module.exports = "/_next/static/images/video_id_7185387594069462314-e54cd9aa34d30396dfb4a884b0568309.jpg";